exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TEXTFIELD */\n\n/* LIST */\n\n/* ==========  Layout  ========== */\n\n/* BUTTON */\n\n/* ANIMATION */\n\n/* Small control size */\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.link-block {\n  display: flex;\n  flex-direction: column;\n  margin-top: 48px;\n}\n\n.link-block a {\n  font-size: 18px;\n  line-height: 36px;\n  color: inherit;\n  width: 300px;\n  padding: 0 10px;\n}\n\n.link-block a:hover {\n  background: #EEE;\n}\n\n.link-block a .material-icons {\n  margin-right: 8px;\n  vertical-align: text-bottom;\n}\n\n", ""]);

// exports
